import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const submitPasswordReset = actionCreator(
  actionTypes.SUBMIT_PASSWORD_RESET,
  ({ email, recaptchaResponse }) => ({
    email,
    recaptchaResponse
  })
)

export const submitPasswordResetSucceeded = actionCreator(
  actionTypes.SUBMIT_PASSWORD_RESET_SUCCEEDED
)

export const submitPasswordResetFailed = actionCreator(
  actionTypes.SUBMIT_PASSWORD_RESET_FAILED
)
